import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LangContext } from '../../../contexts/langContext';
import { SocialContext } from '../../../contexts/socialContext';
import { StateContext } from '../../../contexts/stateContext';
import { Persona } from '../../Persona';
import { PersonaYoni } from '../../PersonaYoni';
import { ListAvatarsLayout } from '../../Lists/ListAvatarsLayout';
import { Button } from '../../UiKit/Button';
import { UserDropDown } from '../../UiKit/UserDropDown';
import { WithVersion } from '../../UiKit/VersionToggler';
import { PentaName } from '../PentaName';
import { PentasChoose } from '../PentasChoose';
import './PentaFolder.css';
import { PopoverH } from '../../UiKit/TooltipH';
import { Icon } from '../../UiKit/Icon';


function PentaFolderItem({
  penta,
  panelExpanded,
  handleChoose,
  mode = 'hd',
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const navigate = useNavigate();
  const cls = panelExpanded ? 'v' : '';
  const isYoni = mode === 'yoni';
  const PersonaCard = isYoni ? PersonaYoni : Persona;
  const pentaPath = (token) => (isYoni ? `/yoni/p/${token}` : `/p/${token}`);

  return (
    <div
      name={`penta_${penta.token}`}
      className={`x_choose_section ${cls ? `x_choose_section--${cls}` : ''} x_choose_section--folder`}
    >
      {panelExpanded && <div className={`x_choose_section_title0 ${cls ? `x_choose_section_title0--${cls}` : ''}`}>
        <div className={`x_choose_section_header ${cls ? `x_choose_section_header--${cls}` : ''}`}>
          <div className="x_choose_section_header_left_group">
            <div
              className={`x_choose_section_title ${cls ? `x_choose_section_title--${cls}` : ''}`}
              style={{ cursor: 'pointer' }}
            >
              <PentaName penta={penta} icon='edit' flat />
              {/* <div className="x_choose_menu_counter">
                {penta.members.length}
              </div> */}
            </div>
            <Button sm ghost iconAfter='arrow_forward' onClick={() => {
              navigate(pentaPath(penta.token));
              context.setState.showPeoplePanel();
            }}><span className='mobile_v_no'>{$ui('penta_open')}</span></Button>
          </div>



          <div className='x_choose_section_header_right _f _fgap1 _f100'>
            <Button sm ghost icon='add' onClick={() => handleChoose(penta.token)}>
              <span className='mobile_vh_no'>{$ui('penta_add_people')}</span>
            </Button>
            <PopoverH
              title={<>
                <Button
                  sm
                  red
                  icon='delete'
                  onClick={() => context.x.deletePenta(penta.token)}
                >{$ui('penta_delete')}</Button>
              </>}
            >
              <div >
                <Button sm ghost red icon='delete'></Button>
              </div>
            </PopoverH>

            {/* <UserDropDown
            penta={penta}
            listId={penta.token}
            actions={['deletePenta']}
            addComponentFirst={<>
              <WithVersion>
                <div
                  className="x_choose_one_menu_li w-inline-block"
                  onClick={() => handleChoose(penta.token)}
                >
                  <div className="t_icon t_icon--20">person_add</div>
                  {$ui('penta_add_people')}
                </div>
              </WithVersion>
            </>}
          /> */}

          </div>

        </div>



      </div>}

      <div className={`x_choose ${panelExpanded ? 'x_choose--v' : ''} x_choose--folder`}>
        {penta.members.map((one) => (
          <PersonaCard
            key={`penta_${penta.token}_persona_${one.avatar.token}`}
            mode={mode}
            listId={penta.token}
            panelExpanded={panelExpanded}
            avatar={one.avatar}
            user={one.user}
            addClassName={panelExpanded ? 'mypeople' : 'people'}
            actions={[{
              title: $ui('penta_delete_from'),
              icon: 'delete',
              action: ({ avatar }) => {
                context.x.deleteFromPenta(penta.token, avatar.token);
              },
            }]}
          />
        ))}
      </div>
    </div>
  );
}


export function PentaFolder({
  children,
  icon = 'diversity_3',
  max = 2,
  min = 0,
  title = '',
  create,
  mode = 'hd',
}) {


  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const panelExpanded = context.state.peoplePanel;

  const [expanded, setExpanded] = useState(false);

  const setExpandedSafe = (val) => {
    if (!val) {
      setExpanded(false);
      if (context.state.pentaChooseId === expanded) {
        context.setState.setPentaChooseId(false);
      }
      return;
    }
    setExpanded(val);
    context.setState.setPentaChooseId(val);
  };

  useEffect(() => {
    const chosenId = context.state.pentaChooseId;
    if (!chosenId) return;

    const penta = context.pentas.find(one => one.token === chosenId);
    const belongsHere = penta
      && penta.members.length > min - 1
      && penta.members.length < max + 1;

    if (belongsHere) {
      setExpanded(chosenId);
    }
  }, [context.state.pentaChooseId])

  useEffect(() => {
    if (!context.state.peoplePanel) {
      setExpanded(false);
      if (context.state.pentaChooseId) {
        context.setState.setPentaChooseId(false);
      }
    }
  }, [context.state.peoplePanel])


  const handleChoose = (val) => {
    if (!context.state.peoplePanel) context.setState.showPeoplePanel(['pentas']);
    setExpandedSafe(val);
  }

  const filteredPentas = context.pentas
    .filter(one => one.members.length > min - 1 && one.members.length < max + 1)
    .sort((a, b) => new Date(b.updated || 0) - new Date(a.updated || 0));
  const count = filteredPentas.length;

  return (
    <>

      <PentasChoose
        pentaId={expanded}
        setExpanded={setExpandedSafe}
        expanded={expanded}
      />

      <ListAvatarsLayout
        icon={icon}
        title={title}
        quantity={count}
        listId='pentas_va'
        className={panelExpanded ? 'v' : ''}
        privateList={true}
        addLeft={create && <div className="x_choose_section_header_left_inner _fgap14">
          <Button sm icon='add' onClick={() => context.x.createPentaWithMe()}>
            <span className='mobile_v_no'>{$ui('button_create_new')}</span>
          </Button>
        </div>}
      >
        {!children && !icon && !title && <div />}
        {children}
        {filteredPentas.map((one) =>
          <PentaFolderItem
            key={`penta_folder_${one.token}`}
            penta={one}
            panelExpanded={panelExpanded}
            handleChoose={handleChoose}
            mode={mode}
          />
        )}
      </ListAvatarsLayout>


    </>
  )
}

